import React from 'react'
import {Badge, Col, Row} from 'react-bootstrap'

const usePayment = () => {
  const getBankLabelByCode = (bankCode: string) => {
    switch (bankCode) {
      case 'kbank':
        return 'ธนาคารกสิกรไทย'
      case 'scb':
        return 'ธนาคารไทยพาณิชย์'
      case 'bbl':
        return 'ธนาคารกรุงเทพ'
      case 'bay':
        return 'ธนาคารกรุงศรีอยุธยา'
      default:
        return bankCode
    }
  }

  const _renderDetailPayCheque = (paymentItem: any) => {
    return (
      <div>
        <Badge bg={'secondary'} className={'px-3'}>{'เช็ค : Cheque'}</Badge>
        <Row>
          <Col xs={6}>
            <p className={'mb-0'}>{`เลขที่เช็ค : ${paymentItem.chequeNumber}`}</p>
          </Col>
          <Col xs={6}>
            <p className={'mb-0'}>{`เลขที่สาขา : ${paymentItem.chequeBranchNumber}`}</p>
          </Col>
          <Col xs={6}>
            <p className={'mb-0'}>{`เลขที่บัญชีในเช็ค : ${paymentItem.chequeAccountNumber}`}</p>
          </Col>
          <Col xs={6}>
            <p className={'mb-0'}>{`ธนาคารที่ระบุไว้ : ${getBankLabelByCode(paymentItem.chequeBank)}`}</p>
          </Col>
          <Col xs={6}>
            <p className={'mb-0'}>{`วันที่ในเช็ค : ${paymentItem.chequeDate}`}</p>
          </Col>
        </Row>
      </div>
    )
  }

  const _renderDetailPayBankAccount = (paymentItem: any) => {
    return (
      <div>
        <Row>
          <Col xs={6}>
            <p className={'mb-0'}>{`ธนาคาร : ${getBankLabelByCode(paymentItem.bank)}`}</p>
          </Col>
          <Col xs={6}>
            <p className={'mb-0'}>{`เลขที่บัญชี : ${paymentItem.accountNo}`}</p>
          </Col>
          <Col xs={6}>
            <p className={'mb-0'}>{`ชื่อบัญชี : ${paymentItem.accountName}`}</p>
          </Col>
        </Row>
      </div>
    )
  }

  return {
    getBankLabelByCode,
    _renderDetailPayCheque,
    _renderDetailPayBankAccount
  }
}

export default usePayment
